import React, { useEffect, useRef } from 'react';
import { Message } from '../../../types/chat';
import { ChatMessage } from './ChatMessage';
import { LoadingIndicator } from './LoadingIndicator';
import { useChatStore } from '../../../store/chatStore';
import { motion } from 'framer-motion';

interface ChatMessagesProps {
  messages: Message[];
}

export function ChatMessages({ messages }: ChatMessagesProps) {
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const isLoading = useChatStore(state => state.isLoading);
  const containerRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isLoading]);

  useEffect(() => {
    const timer = setTimeout(() => {
      scrollToBottom();
    }, 100);
    
    return () => clearTimeout(timer);
  }, []);

  return (
    <div 
      ref={containerRef}
      className="flex-1 overflow-y-auto h-full relative"
      style={{ 
        backgroundColor: '#e5ded8',
        backgroundImage: "url('https://web.whatsapp.com/img/bg-chat-tile-light_a4be512e7195b6b733d9110b408f075d.png')",
        backgroundRepeat: 'repeat',
        backgroundSize: '200px',
        backgroundAttachment: 'local'
      }}
    >
      {/* Content layer */}
      <div className="relative min-h-full p-4">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="space-y-3"
        >
          {messages.map((message, index) => (
            <ChatMessage 
              key={message.id} 
              message={message}
              isFirstMessage={index === 0}
              isLastMessage={index === messages.length - 1}
            />
          ))}
          {isLoading && <LoadingIndicator />}
        </motion.div>
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
}